import { useEffect, useMemo, useState } from 'react';
import debounce from 'lodash/debounce';

interface UseSearchStateProps {
  value: string;
  onChange: (value: string) => void;
  debounceDuration?: number;
}

const DEBOUNCE_DURATION = 200;

export default function useSearchState({
  debounceDuration = DEBOUNCE_DURATION,
  value,
  onChange,
}: UseSearchStateProps) {
  const [searchText, setSearchText] = useState(() => value);

  // this is applicable when the search text is cleared/modified from
  // outside this component
  useEffect(() => {
    if (value !== searchText) {
      setSearchText(value);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [value]);

  const debounceOnChange = useMemo(
    () =>
      debounce(
        (searchValue: string) => {
          onChange(searchValue);
        },
        debounceDuration,
        {
          leading: false,
          trailing: true,
        },
      ),
    [debounceDuration, onChange],
  );

  return {
    searchText,
    debounceOnChange,
    setSearchText,
  };
}
